import { JSX } from 'react';

// Not really necessary but servers as an example
export default function EmptyLayout(
  props: Readonly<{ children: JSX.Element }>,
) {
  return <>{props.children}</>;
}
